import * as React from 'react';
import {styled, emotionStyled} from '@packages/utilities/styled';
import {TabNewIcon} from '@packages/systems/spring';
import {useLink} from './useLink';
import {type LinkProps} from './Link.types';

// @ts-expect-error - TS7031 - Binding element 'theme' implicitly has an 'any' type. | TS7031 - Binding element 'color' implicitly has an 'any' type. | TS7031 - Binding element 'style' implicitly has an 'any' type.
const linkStyles = ({theme, color, style}) => ({
  color: color || theme.colors.foreground,
  backgroundColor: 'transparent',
  cursor: 'pointer',
  fontSize: 'inherit',
  outline: '2px solid transparent',
  textDecoration: 'none',
  display: 'inline-flex',
  ...style,
});

const linkVariants = {
  // @ts-expect-error - TS7031 - Binding element 'theme' implicitly has an 'any' type.
  primary: ({theme}) => ({
    color: theme.colors.accentForeground,
  }),
  // @ts-expect-error - TS7031 - Binding element 'theme' implicitly has an 'any' type.
  warning: ({theme}) => ({
    color: theme.colors.warning,
  }),
  // @ts-expect-error - TS7031 - Binding element 'style' implicitly has an 'any' type.
  hover: ({style}) => ({
    ...style,
    textDecoration: 'underline',
  }),
  // @ts-expect-error - TS7031 - Binding element 'theme' implicitly has an 'any' type.
  keyboardFocus: ({theme}) => ({
    borderRadius: theme.control.borderRadius,
    boxShadow: theme.focusColors.outline,
  }),
  // @ts-expect-error - TS7031 - Binding element 'theme' implicitly has an 'any' type.
  disabled: ({theme}) => ({
    color: theme.colors.foregroundDimmer,
    cursor: 'default',
  }),
  inline: {
    display: 'inline-block',
  },
} as const;

const View = styled('a')(linkStyles, linkVariants);

const IconWrapper = emotionStyled('div')({
  alignItems: 'center',
  justifyContent: 'center',
  display: 'flex',
  marginLeft: 4,
  marginRight: 'auto',
});

/**
 * @deprecated use `Link` from `@packages/systems/spring` instead
 */
export const Link = React.forwardRef<any, LinkProps>((props, ref) => {
  const {children, isExternal, ...rest} = useLink(props);

  return (
    // @ts-expect-error - TS2322 - Type '{ children: (Element | ReactNode)[]; ref: ForwardedRef<any>; href: string | null | undefined; role: string | null; tabIndex: number | null; focus?: boolean | undefined; ... 11 more ...; "data-automation-id"?: string | undefined; } | { ...; } | { ...; } | { ...; }' is not assignable to type 'IntrinsicAttributes & Diff<{ theme: any; color: any; style: any; }, { style?: StyleObject; }> & RefAttributes<any> & { children?: ReactNode; }'.
    <View data-legacy-ds="Link" {...rest} ref={ref}>
      {children}
      {isExternal && (
        <IconWrapper>
          {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
          {/* @ts-expect-error */}
          <TabNewIcon size={11} />
        </IconWrapper>
      )}
    </View>
  );
});

export default Link;
